<template>
  <div class="wf-wrapper">
    <router-view/>
    <div class="footer">
      <snippetPagination></snippetPagination>
      <snippetNavigation></snippetNavigation>
    </div>
  </div>
</template>

<script>
import SnippetNavigation from "./components/SnippetNavigation"
import SnippetPagination from "./components/SnippetPagination"

export default {
  components: {SnippetNavigation,SnippetPagination},
  computed: {
    selectedOptions: {
      get() {
        return this.$store.state.selectedOptions
      }
    }
  },
  mounted() {
    if (!this.selectedOptions.length)
    {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style>
#app {
  font-family: var(--);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
